import React from "react";

// Minimal line-art ghost — same artwork as the email (/email/ghost.png).
export const GhostMark = ({ className = "w-10 h-10", testId }) => (
  <img
    src="/email/ghost.png"
    alt=""
    aria-hidden
    data-testid={testId}
    className={`shrink-0 select-none ${className}`}
    style={{ animation: "ghostFloat 5s ease-in-out infinite" }}
  />
);

export default GhostMark;
